import {ICriteriaColumnsProps} from "../models/CriteriaModels";
import {textSystem} from "../../utils/Constant";
import CustomIconButton from "../../component/custom-icon-button/CustomIconButton";
import {EVALUATE_STATUS, RESULT, TYPE_MODAL} from "../constants/criteriaModal";
import moment from "moment";
import AutocompleteV2 from "../../component/AutocompleteObjectV2";
import {FileActions} from "../components/FileActions";
import TextValidator from "../../component/TextValidator";
import React from "react";

export const ColumnsOf83Criteria = (props: ICriteriaColumnsProps) => {
  const {handleOpenCriteriaModal} = props;
  return [
    {
      name: "STT",
      field: "",
      headerStyle: {
        width: "50px",
      },
      cellStyle: {
        width: "50px",
        textAlign: "center",
        ...textSystem,
      },
      render: (row: any, index: number, stt: number) => <span>{stt}</span>,
    },
    {
      name: "Thao tác",
      field: "",
      headerStyle: {
        width: "100px",
        minWidth: "100px",
      },
      cellStyle: {
        ...textSystem,
      },
      render: (row: any, index: number, stt: number) => (
        <div className="d-flex justify-content-center gap-3">
          <CustomIconButton
            variant="view"
            onClick={() => handleOpenCriteriaModal(TYPE_MODAL.VIEW, row)}
          >
            <i className="bi bi-eye-fill text-gray-700"></i>
          </CustomIconButton>

          {row?.status !== EVALUATE_STATUS.EVALUATED.code && (
            <>
              <CustomIconButton
                variant="edit"
                onClick={() => handleOpenCriteriaModal(TYPE_MODAL.EDIT, row)}
              >
                <i className="bi bi-pencil-square text-primary"></i>
              </CustomIconButton>

              <CustomIconButton
                variant="evaluate"
                onClick={() =>
                  handleOpenCriteriaModal(TYPE_MODAL.EVALUATE, row)
                }
              >
                <i className="bi bi-check2-square text-navy"></i>
              </CustomIconButton>
            </>
          )}
        </div>
      ),
    },
    {
      name: "Hoàn thành đánh giá",
      field: "status",
      headerStyle: {
        width: "160px",
        minWidth: "160px",
      },
      cellStyle: {
        textAlign: "center",
        ...textSystem,
      },
      render: (row: any, index: number, stt: number) => (
        <div>
          {
            Object.values(EVALUATE_STATUS).find(
              (item: any) => item.code === row?.status
            )?.name
          }
        </div>
      ),
    },
    {
      name: "Đợt đánh giá",
      field: "planName",
      cellStyle: {
        minWidth: "200px",
        ...textSystem,
      },
    },
    {
      name: "Phần",
      field: "partCode",
      cellStyle: {
        minWidth: "100px",
        textAlign: "center",
        ...textSystem,
      },
    },
    {
      name: "Chương",
      field: "chapterCode",
      cellStyle: {
        minWidth: "100px",
        textAlign: "center",
        ...textSystem,
      },
    },
    {
      name: "Ngày tạo",
      field: "createdDate",
      cellStyle: {
        minWidth: "150px",
        textAlign: "center",
        ...textSystem,
      },
      render: (row: any, index: number, stt: number) => (
        <div>
          {row?.createdDate
            ? moment(row?.createdDate).format("DD/MM/YYYY")
            : ""}
        </div>
      ),
    },
    {
      name: "Ngày cập nhật",
      field: "modifiedDate",
      cellStyle: {
        minWidth: "150px",
        textAlign: "center",
        ...textSystem,
      },
      render: (row: any, index: number, stt: number) => (
        <div>
          {row?.modifiedDate
            ? moment(row?.modifiedDate).format("DD/MM/YYYY")
            : ""}
        </div>
      ),
    },
  ];
};

export const ColumnsOf83CriteriaModal = (props: any): any[] => {
  const {
    handleChangeTable,
    handleDoubleClick,
    type,
    isView,
    touched,
    errors,
    handleViewFile,
    handleDownloadFile,
  } = props;
  return [
    {
      name: "Tên tiểu mục",
      field: "subsectionName",
      headerStyle: {
        width: "600px",
      },
      cellStyle: {
        ...textSystem,
      },
      render: (row: any, index: number, stt: number) => (
        <div onDoubleClick={() => handleDoubleClick(row)}>
          <span className={`${row?.conclusionAssessment ? "text-navy" : ""}`}>
            {row?.subsectionName}
          </span>
        </div>
      ),
    },
    {
      name:
        type.modalType === TYPE_MODAL.EVALUATE ? "Nhân viên tự đánh giá" : "Tự đánh giá",
      field: "pointSelfAssessment",
      cellStyle: {
        width: "200px",
        minWidth: "200px",
        textAlign: "center",
        ...textSystem,
      },
      render: (row: any, index: number, stt: number) => (
        <div>
          <AutocompleteV2
            options={RESULT}
            value={row?.pointSelfAssessment || null}
            name="pointSelfAssessment"
            onChange={(selectedOption) => {
              handleChangeTable(
                index,
                selectedOption,
                "pointSelfAssessment",
                row
              );
            }}
            className="spaces width-100"
            disabled={isView}
          />
          {touched[`pointSelfAssessment_${index}`] &&
            errors[`pointSelfAssessment_${index}`] && (
              <div className="text-danger small mt-1">
                {errors[`pointSelfAssessment_${index}`]}
              </div>
            )}
        </div>
      ),
    },
    {
      name: "Bằng chứng",
      field: "evidence",
      cellStyle: {
        width: "200px",
        minWidth: "200px",
        textAlign: "center",
        ...textSystem,
      },
      render: (row: any, index: number, stt: number) => (
        <div className="d-flex align-items-center justify-content-center">
          <label className="custom-file-upload">
            <input
              type="file"
              onChange={(e) => {
                const file = e.target.files?.[0];
                handleChangeTable(index, file, "evidence", row);
              }}
              disabled={isView}
            />
            {row?.evidence?.name ? (
              <span className="text-info">{row?.evidence?.name}</span>
            ) : (
              <span className="text-info">
                Tải tệp lên <i className="bi bi-upload text-navy ms-2"></i>
              </span>
            )}
          </label>
          {row?.evidence?.name && (
            <FileActions
              file={row?.evidence}
              onView={handleViewFile}
              onDownload={handleDownloadFile}
              disabled={isView}
            />
          )}
          {touched[`evidence_${index}`] && errors[`evidence_${index}`] && (
            <div className="text-danger small mt-1">
              {errors[`evidence_${index}`]}
            </div>
          )}
        </div>
      ),
    },
    {
      name: "Kết luận",
      field: "conclusionAssessment",
      isVisible: type.modalType === TYPE_MODAL.EVALUATE,
      cellStyle: {
        width: "200px",
        minWidth: "200px",
        textAlign: "center",
        ...textSystem,
      },
      render: (row: any, index: number, stt: number) => (
        <div>
          <AutocompleteV2
            options={RESULT}
            value={row?.conclusionAssessment || null}
            name="conclusionAssessment"
            onChange={(selectedOption) => {
              handleChangeTable(
                index,
                selectedOption,
                "conclusionAssessment",
                row
              );
            }}
            className="spaces width-100"
          />
          {touched[`conclusionAssessment_${index}`] &&
            errors[`conclusionAssessment_${index}`] && (
              <div className="text-danger small mt-1">
                {errors[`conclusionAssessment_${index}`]}
              </div>
            )}
        </div>
      ),
    },
    {
      name: "Ghi chú",
      field: "comment",
      isVisible: type.modalType === TYPE_MODAL.EVALUATE,
      cellStyle: {
        minWidth: "110px",
        ...textSystem,
      },
      render: (row: any, index: number, stt: number) => (
        <div>
          <TextValidator
            className="spaces width-100"
            name="comment"
            value={row?.comment || ""}
            onChange={(e: any) => {
              handleChangeTable(index, e?.target?.value, "comment", row);
            }}
          />
        </div>
      ),
    },
  ];
};
